import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  UntypedFormGroup,
  Validators
} from "@angular/forms";
import {Goal} from "../../models/goal";
import {DialogService} from "../../../tandem-core/services/dialog.service";
import {GoalFormComponent} from "../goal-form/goal-form.component";
import {DateService} from "../../../tandem-core/services/date.service";

@Component({
  selector: 'tandem-goal-card',
  templateUrl: './goal-card.component.html',
  styleUrls: ['./goal-card.component.scss']
})
export class GoalCardComponent implements OnInit, OnChanges {

  @Input() goals: Goal[] = [];
  @Input() goalType: 'Short-Term' | 'Mid-Term' | 'Long-Term' = 'Short-Term';
  @Input() userId: string = '';

  @Input() currentSort: 'ascending' | 'descending' = 'ascending';
  @Input() editable: boolean = true;

  @Output() goalCreated: EventEmitter<Goal> = new EventEmitter<Goal>();
  @Output() goalUpdated: EventEmitter<Goal> = new EventEmitter<Goal>();
  @Output() goalDeleted: EventEmitter<Goal> = new EventEmitter<Goal>();
  @Output() sortGoals: EventEmitter<'Short-Term' | 'Mid-Term' | 'Long-Term'> = new EventEmitter<'Short-Term' | 'Mid-Term' | 'Long-Term'>();



  checksForm = new UntypedFormGroup({});

  constructor(private dialog: DialogService,
              private dateService: DateService,
              private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.checksForm = this.fb.group({
      goals: this.fb.array(this.goals.map(goal => this.fb.control(goal.completed)))
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // TODO add check for if the goals were the thing being updated
    this.checksForm = this.fb.group({
      goals: this.fb.array(this.goals.map(goal => this.fb.control(goal.completed)))
    });
  }

  get goalsFormArray() {
    return this.checksForm.get('goals') as FormArray;
  }
  sortGoal() {
  this.sortGoals.emit(this.goalType)
  }

  getControl(goalControl: AbstractControl<any>) {
    return goalControl as FormControl;
  }

  openGoalDialog() {
    this.dialog.openModal(GoalFormComponent, {goalType: this.goalType, userId: this.userId}).afterClosed().subscribe(goal => {
      if (goal) {
        this.goalCreated.emit(goal);
      }
    })
  }

  getGoalCompletion(): string {
    let completed = this.goals.filter(g => g.completed).length;
    return `${completed} / ${this.goals.length} completed`
  }

  goalIsExpired(index: number) {
    return !this.goals[index].completed && this.goals[index].targetDate.toDate() < new Date();
  }

  onToggle(newValue: boolean, goal: Goal) {
    goal.completed = newValue;
    this.goalUpdated.emit(goal);
  }

  onEdit(goalIndex: number) {
    this.dialog.openModal(GoalFormComponent, {goalType: this.goalType, userId: this.userId, inputGoal: this.goals[goalIndex]}).afterClosed().subscribe(goal => {
      if (goal) {
        this.goalUpdated.emit(goal);
      }
    })
  }

  onDelete(goalIndex: number) {
    this.dialog.openConfirmDialog('Delete Goal', `Are you sure you want to delete your goal called '${this.goals[goalIndex].name}'? This action cannot be undone.`, 'Delete').afterClosed().subscribe(confirmed => {
      if (confirmed) {
        this.goalDeleted.emit(this.goals[goalIndex]);
      }
    })
  }

  getDateString(i: number) {
    return `Started: ${this.dateService.formatDate(this.goals[i]!.startDate!.toDate())} | Target: ${this.dateService.formatDate(this.goals[i].targetDate.toDate())}`
  }

  getLabelForGoal(i: number) {
    return this.goals[i].name
  }
}
